module.exports = __webpack_public_path__ + "img/explosive-rocketry.8319e3e2.png";